export { default } from './RedirectPage';
